import api from './api';

export function getFinancialCommitmentsByCreditId(idCredit) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredit}/financial-obligations`);
}

export function getFinancialEntities() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/bank-entities`);
}
